export default __webpack_public_path__ + "static/media/pic5.2f4675cd.webp";